export default ".password-buttons-container {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}";